/** Default limit for pagination */
export const DEFAULT_LIMIT = 100

export const BASE_URL = import.meta.env.VITE_BACKEND_BASE_URL
